import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { OrganizationDetails } from '@openx/components-organization/lib/components/OrganizationDetails/OrganizationDetails.tsx';
import type { OrganizationsRouteParams } from '@openx/components-organization/lib/types.ts';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { listSearchParams } from '../../utils/useListCriteria.ts';

export const OrganizationDetailsPage = () => {
  const { session } = useAuth();
  const { organizationId = '' } = useParams<OrganizationsRouteParams>();
  const navigate = useNavigate();
  const { useUserDeleteModal, useCreateUser } = useAdministrationContext();
  const handleDeleteUser = useUserDeleteModal({ shouldRedirect: false });
  const { createUser: handleCreateUser } = useCreateUser();

  const isAllowed = useMemo(() => isAdmin(session), [session]);

  const handleGoBack = useCallback(() => {
    navigate(`..?${listSearchParams.organizations ?? ''}`);
  }, [navigate]);

  if (!isAllowed) return <AccessForbiddenPage />;

  return (
    <OrganizationDetails
      handleGoBack={handleGoBack}
      handleCreateUser={handleCreateUser}
      handleDeleteUser={handleDeleteUser}
      organizationId={organizationId}
      titlePrefix={'OpenXSelect'}
    />
  );
};
